"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vuex_1 = require("vuex");
const AppLoading_vue_1 = __importDefault(require("@/components/AppLoading.vue"));
const Quick_vue_1 = __importDefault(require("@/components/Quick.vue"));
const transformations_1 = require("../utils/transformations");
const ENABLE_LOGGING = false;
exports.default = vue_1.default.extend({
    name: 'home',
    data() {
        return {
            isLoading: false,
            error: null,
            quickSettings: null,
        };
    },
    computed: Object.assign({}, vuex_1.mapGetters('user', [
        'user'
    ]), { 
        // days: function(): any {
        //     const days = [
        //     ];
        //     const now = new Date();
        //     now.setHours(0, 0, 0, 0);
        //     const last = now.getTime() / 1000;
        //     for (let i = 0; i < 7; i++) {
        //         days.push({
        //             date: last + i * 7 * 24 * 60 * 60
        //         });
        //     }
        //
        //     return days;
        // },
        data: function () {
            // const store = this.$store.state.user.schedule;
            // if (store) {
            //     const entries = store && store.data ? store.data : null;
            //     const workouts = store && store.workouts ? store.workouts : {};
            //     const exercises = store && store.exercises ? store.exercises : {};
            //     const until = store.until;
            //     console.log("compute data: ", store);
            //     console.log("compute data: ", entries);
            //     // setup schedule array with as many days as are available from the server
            //     const today = new Date();
            //     today.setHours(0, 0, 0, 0);
            //     const todaySec = Math.floor(today.getTime() / 1000);
            //     console.log("todaySec: ", todaySec);
            //     const mindays = Math.ceil((until - todaySec) / 86400);
            //     const schedule = [];
            //     for (let i = 0; schedule.length < mindays; i++) {
            //         schedule.push({
            //             date: todaySec + (i * 86400),
            //             entries: <any>[]
            //         });
            //     }
            //     // setup missed array, for those schedule entries missed
            //     const missed = [];
            //     for (const entry of entries) {
            //         console.log("date was: ", entry.date);
            //         const offset = Math.floor((entry.date - todaySec) / 86400);
            //         console.log("offset was: ", offset);
            //         if (entry.kind === 'workout' || entry.kind === 'exercise') {
            //             if (entry.kind === 'workout' && workouts[entry.foreign_uuid]) {
            //                 entry.title = workouts[entry.foreign_uuid].name;
            //                 entry.link = {
            //                     name: 'workout-detail',
            //                     params: {
            //                         slug: workouts[entry.foreign_uuid].slug
            //                     }
            //                 };
            //             } else if (entry.kind === 'exercise') {
            //                 entry.title = exercises[entry.foreign_uuid].name;
            //                 entry.link = {
            //                     name: 'exercise-detail',
            //                     params: {
            //                         slug: exercises[entry.foreign_uuid].slug
            //                     }
            //                 };
            //             }
            //             if (offset >= 0) {
            //                 if (schedule[offset]) {
            //                     schedule[offset].entries.push(entry);
            //                 } else {
            //                     console.log("WARNING THIS IS off the schedule")
            //                 }
            //             } else {
            //                 missed.push(entry);
            //             }
            //         }
            //     }
            //
            //     return {
            //         missed: missed,
            //         schedule: schedule,
            //         workouts: workouts,
            //         exercises: exercises,
            //         until: until
            //     };
            // } else {
            //     return null;
            // }
            return null;
        } }),
    methods: Object.assign({}, vuex_1.mapActions('user', [
    // TODO add action names here
    ]), { quickstart() {
            if (ENABLE_LOGGING)
                console.log("quickstart Called, ", this.quickSettings);
            if (this.quickSettings) {
                this.$router.push({ path: '/quickstart', query: transformations_1.dataToQueryObject(this.quickSettings, true) });
            }
        },
        login() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.$data.isLoading = true;
                    yield this.$store.dispatch('user/login');
                    this.$data.isLoading = false;
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                }
            });
        },
        logout() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.$data.isLoading = true;
                    yield this.$store.dispatch('user/logout');
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                }
                finally {
                    this.$data.isLoading = false;
                }
            });
        } }),
    watch: {
    // user: {
    //     handler: function (user) {
    //         console.log("watched user: ", user);
    //         if (user) {
    //             this.getSchedule();
    //         } else {
    //             // TODO remove schedule
    //         }
    //     },
    //     immediate: true
    // }
    },
    components: {
        AppLoading: AppLoading_vue_1.default,
        Quick: Quick_vue_1.default
    }
});
